import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { GridStack, GridStackOptions } from "gridstack";
import "gridstack/dist/h5/gridstack-dd-native";
import { Widget } from "../../dashboard/widgets/widgets";

@Component({
  selector: "grid-stack",
  templateUrl: "./grid-stack.component.html",
  styleUrls: ["./grid-stack.component.scss"],
})
export class GridStackComponent implements OnInit, AfterViewInit {
  @Input() widgets!: Widget[];
  @Input() gridStackOptions?: GridStackOptions;
  @Output() onGridInit = new EventEmitter<void>();
  grid!: GridStack;
  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.grid = GridStack.init(
      this.gridStackOptions ?? {
        disableDrag: true,
        disableResize: true,
        disableOneColumnMode: true,
        cellHeight: "150px",
      },
    );
    this.onGridInit.emit();
  }
}
